import styled from '@emotion/styled';
import { isGov } from '@kc-console/context';
import { RouterLink } from '@kc-console/shared-ui';

import { ROUTE_PATH } from '@/shared/config/routes';

export default function GnbLogoLink() {
  return (
    <GnbLogoAnchor tabIndex={0} href={ROUTE_PATH.SERVICE_LIST}>
      {isGov() ? (
        <img
          src="https://t1.kakaocdn.net/kic_console/brand/logo_white_gov.svg"
          alt="kakao-cloud-gnb-logo"
          width={167}
          height={32}
        />
      ) : (
        <img
          src="https://t1.kakaocdn.net/kic_console/brand/logo_white.svg"
          alt="kakao-cloud-gnb-logo"
          width={104}
          height={32}
        />
      )}
    </GnbLogoAnchor>
  );
}

const GnbLogoAnchor = styled(RouterLink)(({ theme }) => ({
  display: 'flex',
  padding: '8px 24px',
  ':hover': {
    backgroundColor: theme.color['surface/transparent/strong/hover'],
  },
  ':active': {
    backgroundColor: theme.color['surface/transparent/strong/press'],
  },
  ...theme.mixins.focusRing('inside', { inverse: true }),
}));
